import React from 'react'

export default function FibPivot({item}) {
  return (<>
    <tr className="table_rows">
                <td className="boldfont">Daily</td>
                <td className="boldfont">PP</td>
                <td>{item.fpp ? item.fpp : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.fsone ? item.fsone : ""} </td>
                <td className="boldfont">R1</td>
                <td>{item.frone ? item.frone : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td>{item.fstwo ? item.fstwo : ""} </td>
                <td className="boldfont">R2</td>
                <td>{item.frtwo ? item.frtwo : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.fsthree ? item.fsthree : ""} </td>
                <td className="boldfont">R3</td>
                <td>{item.frthree ? item.frthree : ""} </td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont">Weekly</td>
                <td className="boldfont">PP</td>
                <td>{item.fwpp ? item.fwpp : ""} </td>
                <td></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.fwsone ? item.fwsone : ""} </td>
                <td className="boldfont">R1</td>
                <td>{item.fwrone ? item.fwrone : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td> {item.fwstwo ? item.fwstwo : ""}</td>
                <td className="boldfont">R2</td>
                <td>{item.fwrtwo ? item.fwrtwo : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.fwsthree ? item.fwsthree : ""} </td>
                <td className="boldfont">R3</td>
                <td>{item.fwrthree ? item.fwrthree : ""} </td>
              </tr>
              <tr className="table_rows highlited_row">
                <td>Monthly</td>
                <td className="boldfont">PP</td>
                <td>{item.fmpp ? item.fmpp : ""} </td>
                <td></td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.fmsone ? item.fmsone : ""} </td>
                <td className="boldfont">R1</td>
                <td> {item.fmrone ? item.fmrone : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td>{item.fmstwo ? item.fmstwo : ""} </td>
                <td className="boldfont">R2</td>
                <td> {item.fmrtwo ? item.fmrtwo : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.fmsthree ? item.fmsthree : ""} </td>
                <td className="boldfont">R3</td>
                <td> {item.fmrthree ? item.fmrthree : ""}</td>
              </tr>
              </>
  )
}
